import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'
import { DetailPageActionTypes, DetailPageActions } from '../actions'
import { Reducer, combineReducers } from 'redux'
import * as actions from '../actions'
import { tuple } from '../utils/utils'

export const ATF_DECORATION_SCHEME = 'atf'
export const BTF_DECORATION_SCHEME = 'btf'
export const decorationSchemes = tuple([
  ATF_DECORATION_SCHEME,
  BTF_DECORATION_SCHEME,
])
export type DecorationSchemeType = typeof decorationSchemes[number]
export type IActionState = { [D in DecorationSchemeType]: TitleIdToAction }
export type ActionFragment =
  | WpsTypes.atv.wps.ActionFragmentModelProps
  | undefined
export interface TitleIdToAction {
  [titleId: string]: ActionFragment
}
type ReducerType = Record<
  DecorationSchemeType,
  Reducer<TitleIdToAction, actions.DetailPageActions>
>

const initialState = {} as TitleIdToAction

const actionReducer = (
  decorationScheme: DecorationSchemeType
): Reducer<TitleIdToAction, DetailPageActions> => (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DetailPageActionTypes.RefreshAtfActionBox:
    case DetailPageActionTypes.RefreshBtfActionBoxes:
    case DetailPageActionTypes.RefreshEpisode:
      return (
        (action.output &&
          action.output.action &&
          action.output.action[decorationScheme] && {
            ...state,
            ...action.output.action[decorationScheme],
          }) ||
        state
      )
    default:
      return state
  }
}

const createActionreducer = (decorationScheme: DecorationSchemeType) =>
  createMergeReducer(
    t => t.action && t.action[decorationScheme],
    initialState,
    actionReducer(decorationScheme)
  )

export const reducer = combineReducers<IActionState, actions.DetailPageActions>(
  decorationSchemes.reduce(
    (acc, scheme) => {
      acc[scheme] = createActionreducer(scheme)
      return acc
    },
    {} as Partial<ReducerType>
  ) as ReducerType
)
